import { Object3D, MeshStandardMaterial, Mesh, PlaneGeometry } from "three";

export default class GroundPlane extends Object3D {
  static _geometry = new PlaneGeometry(200, 200);

  static disableCursor = true;

  constructor() {
    super();

    this._receiveShadow = true;

    const material = new MeshStandardMaterial({
      roughness: 1,
      metalness: 0,
      color: "#5DE336"
    });
    const mesh = new Mesh(GroundPlane._geometry, material);
    mesh.name = "GroundPlaneMesh";
    mesh.position.y = -0.05;
    mesh.rotation.x = -Math.PI / 2;
    this.mesh = mesh;
    this.mesh.receiveShadow = this.receiveShadow;
    this.add(this.mesh);
  }

  get color() {
    return this.mesh.material.color;
  }

  get receiveShadow() {
    return this._receiveShadow;
  }

  set receiveShadow(value) {
    this._receiveShadow = value;

    if (this.mesh) {
      this.mesh.receiveShadow = value;

      const material = this.mesh.material;

      if (Array.isArray(material)) {
        for (let i = 0; i < material.length; i++) {
          material[i].needsUpdate = true;
        }
      } else {
        material.needsUpdate = true;
      }
    }
  }

  copy(source, recursive = true) {
    if (recursive) {
      this.remove(this.mesh);
    }

    super.copy(source, recursive);

    if (recursive) {
      const meshIndex = source.children.indexOf(source.mesh);

      if (meshIndex !== -1) {
        this.mesh = this.children[meshIndex];
      }
    }

    this.color.copy(source.color);

    return this;
  }
}

AFRAME.registerComponent("ground-plane", {
  schema: {
    color: { type: "string", default: "#5DE336" },
    receiveShadow: { default: true },
    walkable: { default: true }
  },

  init() {
    this.plane = new GroundPlane();
    this.el.setObject3D("ground-plane", this.plane.mesh);
    this.el.object3D.scriptableType = "ground-plane";

    const halfExtents = {
      x: 100,
      y: 0.1,
      z: 100
    };

    this.el.setAttribute("shape-helper", {
      type: "box",
      fit: "manual",
      halfExtents: halfExtents
    });

    this.el.setAttribute("shadow", { receive: this.data.receiveShadow, cast: false });
  },

  update(prevData = {}) {
    if (this.data.color !== prevData.color) {
      this.plane.color.set(this.data.color);
      if (this.plane.color.convertSRGBToLinear) {
        this.plane.color.convertSRGBToLinear();
      }
    }

    if (this.data.receiveShadow !== prevData.receiveShadow) {
      this.plane.receiveShadow = this.data.receiveShadow;
    }
  },

  remove() {
    this.el.removeObject3D("ground-plane");
  }
});
